(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["banner"] && !Shopify.designMode) return;
  try {
    $(document).ready(() => {
    $('.o-banners.-isCarousel .bannersList').each((i, el) => {
      var slickConf = {
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        controls: false,
        autoplay: true,
        autoplaySpeed: 5000,
        customPaging: function customPaging(slick, index) {
          return "<button type=\"button\" data-role=\"none\" role=\"button\" tabindex=\"0\">".concat(index, "</button>")
        }
      }

      $(el).not('.slick-initialized').slick(slickConf)
    })

    $('.banner .footerCtaList').each((i, el) => {
      var slickConf = {
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        controls: false,
        autoplay: true,
        autoplaySpeed: 5000,
        customPaging: function customPaging(slick, index) {
          return "<button type=\"button\" data-role=\"none\" role=\"button\" tabindex=\"0\">".concat(index, "</button>")
        },
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      }

      $(el).not('.slick-initialized').slick(slickConf)
    })
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["media-text-carousel"] && !Shopify.designMode) return;
  try {
    $(document).ready(() => {
        $('.media-text-carousel-block .primary-calls-to-action .ctaList').each((i, el) => {
            var slickConf = {
                arrows: false,
                dots: false,
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                controls: false,
                autoplay: true,
                autoplaySpeed: 5000,
                touchThreshold: 10, // a shorter swipe moves on a card
                swipeToSlide: true,
                waitForAnimate: false, // don't ignore a swipe or arrow tap while a card is still moving
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    }
                ]
            }

            $(el).parent().find('.controls .control').click(e => {
                const isPrevArrow = $(e.currentTarget).hasClass('slick-prev')
                $(el).slick('slickPause').slick(isPrevArrow ? 'slickPrev' : 'slickNext')
            })

            $(el).not('.slick-initialized').slick(slickConf)

            // once someone swipes, stop autoplay so the carousel doesn't move under them
            $(el).on('swipe', () => $(el).slick('slickPause'))
        })
    })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["products-carousel"] && !Shopify.designMode) return;
  try {
    $(document).ready(() => {
  $('.products-carousel-block .products-list').each((i, el) => {
    var slickConf = {
      arrows: false,
      dots: false,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      controls: false,
      autoplay: true,
      autoplaySpeed: 5000,
      touchThreshold: 10, // a shorter swipe moves on a slide
      swipeToSlide: true,
      waitForAnimate: false, // don't ignore a swipe or arrow tap while a slide is still moving
      prevArrow: $(el).parent().find('.controls .slick-prev'),
      nextArrow: $(el).parent().find('.controls .slick-next'),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          }
        },
        {
        breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        },
      ]
    }

    jQuery(el).parent().find('.controls .control').click(e => {
      const isPrevArrow = $(e.currentTarget).hasClass('slick-prev')
      const primarySlick = $(el)
      if(primarySlick?.length) $(primarySlick).slick('slickPause').slick(isPrevArrow ? 'slickPrev' : 'slickNext')
    })

    $(el).not('.slick-initialized').slick(slickConf)

    // once someone swipes, stop autoplay so the carousel doesn't move under them
    $(el).on('swipe', () => $(el).slick('slickPause'))
  })
})
  } catch(e) { console.error(e); }
})();

})();
